<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-card>
        <h3 class="card-title d-flex">
          Participants list of {{ this.$route.query.contest }}
          <vs-button class="ml-auto" type="filled" icon="add_circle" size="small" @click="addingNewItem">Add New
            participants</vs-button>
        </h3>
        <p class="card-subtitle">
          Participants list of {{ this.$route.query.contest }}.
        </p>
        <!-- <vs-row>
          <vs-col class="d-flex drop-width" vs-lg="2" vs-xs="12">
            <vs-select
              :color="colorx"
              label="Language Filter"
              v-model="search.language"
            >
              <vs-select-item value="all" text="All Languages" />
              <vs-select-item
                :key="index"
                :value="item.culture"
                :text="item.culture"
                v-for="(item, index) in languages"
              />
            </vs-select>
          </vs-col>
          <vs-col class="d-flex drop-width" vs-lg="2" vs-xs="12">
            <vs-select
              :color="colorx"
              label="Sorting Type"
              v-model="search.sort"
            >
              <vs-select-item value text="Select Sorting" disabled />
              <vs-select-item value="ASC" text="Ascending" />
              <vs-select-item value="DESC" text="Descending" />
            </vs-select>
          </vs-col>
          <vs-col class="d-flex drop-width" vs-lg="2" vs-xs="12">
            <vs-select
              :color="colorx"
              label="Status Filter"
              v-model="search.status"
            >
              <vs-select-item value text="Select Status" disabled />
              <vs-select-item value="1" text="Active" />
              <vs-select-item value="2" text="Inactive" />
            </vs-select>
          </vs-col>
          <vs-col class="d-flex drop-width" vs-lg="2" vs-xs="12">
            <vs-select
              :color="colorx"
              label="Day Filter"
              v-model="search.isToday"
            >
              <vs-select-item value text="Select Day" disabled />
              <vs-select-item value="false" text="All" />
              <vs-select-item value="true" text="Today" />
            </vs-select>
          </vs-col>
          <vs-col vs-lg="4" vs-xs="12">
            <vs-button
              color="primary"
              type="filled"
              class="searchBtn"
              @click="searchData()"
              icon="search"
              >Search</vs-button
            >
            <vs-button
              color="warning"
              type="filled"
              class="searchBtn"
              icon="cached"
              @click="resetData()"
              >Reset</vs-button
            >
          </vs-col>
        </vs-row> -->
        <br />
        <table class="table">
          <tr>
            <th>#</th>
            <td></td>
            <th>Name</th>
            <th>Email</th>
            <th>Participant Id</th>
            <th>Address</th>
            <th>Mobile</th>
            <th>Vote</th>
            <th>Position</th>
            <th>Status</th>
            <th></th>
          </tr>
          <tr v-for="(item, index) in all" :key="item.name">
            <td class="td">{{ index + 1 }}</td>
            <td>
              <div class="row">
                <div class="mr-2" v-for="url in item.file" :key="url._id">
                  <img v-if="!url.url" src="../../../assets/images/No-image.png" height="50px" width="75px" />
                  <img v-if="url.url" :src="url.url" height="50px" width="75px" />
                </div>
                <!-- <div class="mr-2" v-if="!all.file">
                  <img
                    src="../../../assets/images/No-image.png"
                    height="50px"
                    width="75px"
                  />
                </div> -->
              </div>
            </td>
            <td class="td">
              {{ item.name }}
            </td>
            <td class="td">
              {{ item.email }}
            </td>
            <td class="td">
              {{ item.participantId }}
            </td>
            <td class="td">{{ item.address }}</td>
            <td class="td">{{ item.mobile }}</td>
            <!-- <td class="td">{{ item.rules }}</td> -->
            <td class="td text-center">{{ item.vote }}</td>
            <td class="td text-center">{{ item.position }}</td>
            <td class="td">
              <vs-chip v-if="item.active" color="success">Active</vs-chip>
              <vs-chip v-else color="danger">Inactive</vs-chip>
            </td>
            <td class="td">
              <vs-button class="mr15" icon="create" size="small" color="warning"
                @click="editingItem(item, 'edit')">Edit</vs-button>
              <vs-button class="mr15" size="small" color="danger" icon="delete_sweep" @click="
                deleteBannerPopup = true;
              itemToDelete = item;
              ">Delete</vs-button>
              <vs-button class="mr15" size="small" color="primary"
                @click="editingItem(item, 'clone')">Duplicate</vs-button>
            </td>
          </tr>
        </table>

        <!-- Code -->
        <vs-popup :title="isNew
          ? 'Add New Participant'
          : clone
            ? 'Duplicate Participant'
            : 'Edit Participant'
          " :active.sync="defaultalert">
          <vs-row>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-input label="Participant Name*" v-model="banner.name" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-input label="Participant Email*" v-model="banner.email" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <label>Participant Address*</label>
              <vs-textarea width="100%" v-model="banner.address" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-input type="number" label="Participant Mobile Number*" v-model="banner.mobile" :min="1" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-input label="Participant ID*" v-model="banner.participantId" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-input type="number" label="Participant Position (Try to assign different position)" :min="1"
                v-model="banner.position" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12" class="mt-4">
              <vs-checkbox v-model="banner.active">Status (Active / Inactive)</vs-checkbox>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12" class="mb15 mt20">
              <div>
                <vs-col vs-lg="12" vs-xs="12">
                  <div class="upload-btn-wrapper vs-input-primary">
                    <label class="vs-input--label">Participant Image</label>
                    <div class="btn">
                      <vs-icon icon="cloud_upload" class="icon-medium"></vs-icon>Upload a File
                    </div>
                    <input type="file" ref="fileInput" @change="uploadImage($event)" />
                  </div>
                </vs-col>
                <vs-col v-if="displayImage1.length">
                  <div class="row">
                    <div class="mr-2" v-for="url in displayImage1" :key="url._id">
                      <vs-button color="danger" type="flat" icon="clear" class="closeBtn"
                        @click="deleteImage(url)"></vs-button>
                      <img :src="url.url" class="imgUp" height="100px" width="150px" />
                    </div>
                  </div>
                </vs-col>
              </div>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12" class="mt-2">
              <vs-button icon="save" @click="btnAddParticipant">Save</vs-button>
            </vs-col>
          </vs-row>
        </vs-popup>

        <vs-popup class="holamundo" title="Delete Participant" :active.sync="deleteBannerPopup">
          <p>Are you sure you want to delete Participant?</p>
          <div>
            <vs-button icon="delete_forever" class="mr15" @click="deleteParticipant">Delete Participant</vs-button>
            <vs-button icon="clear" @click="deleteBannerPopup = false">Cancel</vs-button>
          </div>
        </vs-popup>

        <!-- Code -->
      </vs-card>
    </vs-col>
  </vs-row>
</template>

<script>
// import uploader from "../common/uploader.vue";
import api from "@/rest.js";
import { API } from "@/common/constants";
// import { generateChart } from 'vue-chartjs';
// import Datepicker from "vuejs-datepicker";
import moment, { min } from "moment";
import Vue from "vue";

Vue.filter("formatDate", function (value) {
  if (value) {
    return moment(String(value)).format("DD-MM-YYYY");
  }
});

export default {
  name: "banner",
  components: {
    // uploader,
    // Datepicker,
  },
  data: () => ({
    title: "Contest",
    colorx: "#0D2144",
    defaultalert: false,
    viewDetails: false,
    deleteBannerPopup: false,
    isNew: true,
    clone: false,
    search: {
      sort: "ASC",
      language: "all",
      status: "1",
      isToday: "false",
    },
    displayImage1: [],
    fileName1: "",
    displayImage2: "",
    fileName2: "",
    displayImage3: "",
    fileName3: "",
    banner: {
      address: "",
      email: "",
      mobile: "",
      vote: "",
      image: [],
      contestId: "",
      name: "",
      participantId: "",
      position: "",
      active: false,
    },
    itemToDelete: "",
    itemToUpdate: "",
    all: [],
    languages: [],
    detail: {},
  }),
  methods: {
    addingNewItem() {
      this.$data.defaultalert = true;
      this.$data.isNew = true;
      this.$data.banner = {
        numberOfWinners: "",
        title: "",
        image: [],
      };
      this.$data.displayImage1 = [];
      this.$data.fileName1 = "";
    },
    editingItem(i, data) {
      this.$data.banner = Object.assign({}, i);
      this.$data.defaultalert = true;
      this.$data.isNew = false;
      this.$data.displayImage1 = i.file;
      this.$data.clone = data == "clone" ? true : false;
    },
    uploadImage(data) {
      const imageType = ["image/jpeg", "image/jpg", "image/webp"];
      var isValid = false;
      isValid = imageType.indexOf(data.target.files[0].type) > -1

      if (!isValid) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "Only JPEG,JPG,WEBP Image files formats should be supported",
          color: "danger",
          position: "top-right",
        });
        this.$refs.fileInput.value = null;
        return;
      }
      if (data.target.files[0].size > 500000) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "File size should be less than 500kb",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      let formdata = new FormData();

      formdata.append("file", data.target.files[0]);
      formdata.append("banner", this.$data.banner.title);
      this.$vs.loading();
      api
        .post(API.UPLOAD_IMAGE, formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.error != null) {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Uploading Error",
              text: response.data.error.message,
              color: "danger",
              position: "top-right",
            });
          } else {
            const data = response;
            this.$data.displayImage1.push(data.data.files[0]);
            this.$data.banner.file = this.$data.displayImage1;
            if (response) {
              this.$vs.notify({
                text: "File Uploaded",
                color: "success",
                position: "top-right",
              });
              this.$vs.loading.close();
            } else {
              this.$vs.loading.close();
              this.$vs.notify({
                text: "File Uploading Failed",
                color: "danger",
                position: "top-right",
              });
            }
            this.$refs.fileInput.value = null;
            this.$emit("input", data);
          }
        })
        .catch(() => { });
      this.$vs.loading.close();
    },
    deleteImage(item) {
      const index = this.$data.displayImage1.indexOf(item);
      if (index > -1) {
        this.$data.displayImage1.splice(index, 1);
      }
    },
    btnAddParticipant() {
      // let apiToCall = API.ADD_PARTICIPANT;
      let data = this.$data.banner;
      this.$data.banner.contestId = this.$route.query.id;
      this.$data.banner.file = this.$data.displayImage1;
      if (!data.name) {
        this.$vs.notify({
          title: "Participant name required",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      if (!data.email) {
        this.$vs.notify({
          title: "Participant email required",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(data.email)) {
        this.$vs.notify({
          title: "Enter valid email address",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      if (!data.address) {
        this.$vs.notify({
          title: "Participant address required",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      if (!data.mobile) {
        this.$vs.notify({
          title: "Participant mobile number required",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      if (data.mobile && data.mobile.length != 10) {
        this.$vs.notify({
          title: "Mobile number required 10 digit",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      if (!data.participantId) {
        this.$vs.notify({
          title: "Participant ID required",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      if (!this.$data.displayImage1.length) {
        this.$vs.notify({
          title: "Participant image required",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      if (!this.$data.isNew && !this.$data.clone) {
        this.updateParticipant();
        return;
      } else if (this.$data.clone) {
        let data = {
          file: this.$data.banner.file,
          contestId: this.$route.query.id,
          email: this.$data.banner.email,
          name: this.$data.banner.name,
          address: this.$data.banner.address,
          mobile: this.$data.banner.mobile,
          active: this.$data.banner.active,
          position: this.$data.banner.position,
          participantId: this.$data.banner.participantId,
        };

        this.createParticipant(data);
      } else {
        this.createParticipant(data);
      }
    },
    createParticipant(data) {
      let apiToCall = API.ADD_PARTICIPANT;
      this.$vs.loading();
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }
      api
        .post(apiToCall, data, { headers })
        .then((r) => {
          this.$vs.loading.close();
          if (r.data) {
            this.$vs.notify({
              text: "Saved Successfully",
              color: "success",
              position: "top-right",
            });
            this.$data.isNew = true;
            this.$data.itemToUpdate = "";
            this.$data.defaultalert = false;
            (this.$data.banner = {
              numberOfWinners: "",
              title: "",
              image: {
                image1: "",
              },
            }),
              this.fetchAllParticipants();
          } else {
            this.$vs.notify({
              title: "Error",
              text: r.data.error,
              color: "danger",
              position: "top-right",
            });
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: error.response.data.error,
            color: "danger",
            position: "top-right",
          });
        });
    },
    updateParticipant() {
      this.$vs.loading();
      let data = this.$data.banner;
      this.$data.banner.contestId = this.$route.query.id;
      this.$data.banner.file = this.$data.displayImage1;
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }
      api
        .put(API.UPDATE_PARTICIPANT + "?id=" + data._id, data, { headers })
        .then((r) => {
          this.$vs.loading.close();
          if (r.data) {
            this.$vs.notify({
              text: "Updated Successfully",
              color: "success",
              position: "top-right",
            });
            this.$data.isNew = true;
            this.$data.itemToUpdate = "";
            this.$data.defaultalert = false;
            (this.$data.banner = {
              numberOfWinners: "",
              title: "",
              image: {
                image1: "",
              },
            }),
              this.fetchAllParticipants();
          } else {
            this.$vs.notify({
              title: "Error",
              text: r.data.error,
              color: "danger",
              position: "top-right",
            });
          }
        })
        .catch(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: "Participant already exist",
            color: "danger",
            position: "top-right",
          });
        });
    },
    fetchAllParticipants() {
      this.$vs.loading();
      api
        .get(API.GET_PARTICIPANT + "?id=" + this.$route.query.id)
        .then((r) => {
          this.$vs.loading.close();
          this.$data.all = r.data;
          if (!r.data) {
            this.$vs.notify({
              title: "Error",
              text: r.data.error,
              color: "danger",
              position: "top-right",
            });
          }
        })
        .catch(() => { });
    },
    deleteParticipant() {
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };
      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }
      api
        .delete(
          API.DELETE_PARTICIPANT + "?id=" + this.$data.itemToDelete._id,
          {},
          { headers }
        )
        .then((r) => {
          if (r.data) {
            this.$vs.notify({
              text: "Deleted Successfully",
              color: "success",
              position: "top-right",
            });
          } else {
            this.$vs.notify({
              text: "Already Deleted",
              color: "danger",
              position: "top-right",
            });
          }
          this.$data.deleteBannerPopup = false;
          this.fetchAllParticipants();
        })
        .catch(() => { });
    },
    resetData() {
      this.$data.search = {
        sort: "ASC",
        language: "all",
        status: "1",
        isToday: "false",
      };
      //   this.searchData();
    },
    viewBannerDetails(i) {
      this.$data.detail.description = i.description;
      this.$data.detail.link = i.link;
      this.$data.viewDetails = true;
    },
  },
  created() {
    this.fetchAllParticipants();
  },
};
</script>
<style scoped>
.mb15 {
  margin-bottom: 15px;
}

.mr15 {
  margin-right: 15px;
}

.td {
  vertical-align: middle;
}

.mt20 {
  margin-top: 20px;
}

.searchBtn {
  margin-top: 25px;
  margin-right: 5px;
  width: 30%;
}

.eye {
  cursor: pointer;
  margin: auto;
}

.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  width: 100%;
  cursor: pointer !important;
}

.btn {
  border: 1px solid rgba(0, 0, 0, 0.2);
  background-color: white;
  padding: 0.4rem;
  border-radius: 0px;
  font-size: 0.85rem;
  width: 100%;
  cursor: pointer;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}

td {
  padding: 0.5rem;
}

.drop-width {
  width: 150px !important;
}
</style>
